import React from 'react';
import type { GamificationConfig } from '@troia-v3/types';

import { Switch } from '@/shared/components/ui';

import { SettingsSection } from './SettingsSection';

type Celebrate = GamificationConfig['celebrate'];
interface Props { value: Celebrate; onChange: (v: Celebrate) => void; disabled?: boolean }

/** Linha de toggle no padrão do form de canal: rótulo + descrição à esquerda, Switch à direita. */
const ToggleRow: React.FC<{ id: string; label: string; description?: string; checked: boolean; onChange: (v: boolean) => void; disabled: boolean; testId: string }> = ({ id, label, description, checked, onChange, disabled, testId }) => (
  <div className="flex items-start justify-between gap-4">
    <div className="flex-1 min-w-0">
      <label htmlFor={id} className="block text-sm font-medium mb-1" style={{ color: 'var(--theme-card-text)' }}>{label}</label>
      {description && <p className="text-xs" style={{ color: 'var(--theme-card-muted)' }}>{description}</p>}
    </div>
    <Switch id={id} checked={checked} onChange={onChange} disabled={disabled} aria-label={label} data-testid={testId} />
  </div>
);

export const CelebrationSection: React.FC<Props> = ({ value, onChange, disabled = false }) => (
  <SettingsSection icon="zap" title="Celebração" description="Pequenos reforços no momento certo. Nada de pop-up invasivo." testId="gamification-section-celebration">
    <ToggleRow id="gamification-celebrate-onComplete" label="Mostrar pontos ganhos ao concluir um atendimento" checked={value.onComplete} onChange={(v) => onChange({ ...value, onComplete: v })} disabled={disabled} testId="gamification-celebrate-onComplete" />
    <ToggleRow id="gamification-celebrate-onWon" label="Avisar a equipe quando alguém fecha uma venda" description="Toast discreto para quem estiver online no recorte do vendedor." checked={value.onWon} onChange={(v) => onChange({ ...value, onWon: v })} disabled={disabled} testId="gamification-celebrate-onWon" />
    <ToggleRow id="gamification-celebrate-sound" label="Som na celebração" checked={value.sound} onChange={(v) => onChange({ ...value, sound: v })} disabled={disabled} testId="gamification-celebrate-sound" />
  </SettingsSection>
);
CelebrationSection.displayName = 'CelebrationSection';
